import BulletPointsCard from '../BulletPointsCard'
import Market from '../../Icons/coaching/market.svg'
import List2 from '../../Icons/coaching/list-2.svg'
import Mailing from '../../Icons/coaching/mailing.svg'

const bulletPoints = [
    {
        title: 'Market Evaluation',
        description:
            'We will thoroughly assess your market to identify unique opportunities and challenges.',
        icon: Market,
    },
    {
        title: 'Optimal List Criteria',
        description:
            'Determine the best list criteria and find the most accurate data sources tailored to your market.',
        icon: List2,
    },
    {
        title: 'Mailing Sequence Planning',
        description:
            'Develop an effective mailing sequence for multi-touch campaigns to maximize engagement and response rates.',
        icon: Mailing,
    },
]

function CampaignStrategy(props) {
    return (
        <BulletPointsCard
            {...props}
            title="Campaign Strategy"
            imageAlt="An overhead shot of two people collaborating at a wooden table, working on a large paper with a colorful mind map and flow chart centered around a red rocket icon. The table also holds a laptop, a notebook, a camera, and a cup of coffee."
            imageTitle="Two people working on a business strategy or design plan."
            bulletPoints={bulletPoints}
            imagePath="/assets/coaching/1.png"
            mobileImagePath="/assets/coaching/1-mobile.png"
            alignment={'left'}
            bg="bg-light-yellow-gradient"
        />
    )
}

export default CampaignStrategy
